export default "__VITE_ASSET__D6HIPGV4__"